import React, { useState, useEffect } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function ServiceRequestUpdateForm({ request, clients, agents, rerender }) {
  const [formData, setFormData] = useState({
    policyNumber: "",
    carrier: "",
    effectiveDate: "",
    clientFirstName: "",
    clientLastName: "",
    BI: "",
    PD: "",
    UM: "",
    UIM: "",
    TORT: "",
    premium: "",
    mainAgent: "",
    mainAgentSplit: "",
    refAgentOne: "",
    refAgentOneSplit: "",
    refAgentTwo: "",
    refAgentTwoSplit: "",
    refAgentThree: "",
    refAgentThreeSplit: "",
    refAgentFour: "",
    refAgentFourSplit: "",
    clientID: "",
    agent: ""
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    console.log("Service Request Update FormLaunched with props:");
    console.log(request);
    setFormData((prev) => ({
      ...prev,
      name: request.name,
      email: request.email,
      type: request.type,
      phone: request.phone,
      message: request.message,
      clientID: request.clientID,
      agent: request.agent
    }));

    setTimeout(() => {
      console.log("Servie Request Update Form State:");
      console.log(formData);
    }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleServiceRequestUpdate = (event) => {
    event.preventDefault();

    const serviceRequestInformation = {
      name: formData.name,
      email: formData.email,
      type: formData.type,
      phone: formData.phone,
      message: formData.message,
      clientID: formData.clientID,
      agentID: formData.agentID
    };

    API.updateServiceRequest(request._id, {
      name: formData.name,
      email: formData.email,
      type: formData.type,
      phone: formData.phone,
      message: formData.message,
      agent: formData.agent,
      client: formData.clientID
    })
      .then((_res) => {
        console.log("Saved Service Request Policy");
        cogoToast.success("Updated Service Request");
        rerender();
      })
      .catch((_err) => console.log(_err));

    console.log(serviceRequestInformation);
  };

  const getClientNameFromID = (id) => {
    for (let i = 0; i < clients.length; i++) {
      if (id === clients[i]._id) {
        return clients[i].firstName + " " + clients[i].lastName;
      }
    }
  };

  const getAgentNameFromID = (id) => {
    for (let i = 0; i < agents.length; i++) {
      if (id === agents[i]._id) {
        return agents[i].firstName + " " + agents[i].lastName;
      }
    }
  };

  return (
    <div>
      <div className="card">
        <h5 style={{ textAlign: "center" }}>Update a Service Request</h5>
        <div className="card-body">
          <form>
            <Table bordered hover>
              <tbody>
                <tr>
                  <td>Question</td>
                  <td>Input</td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Client Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.name}
                      onChange={handleInputChange}
                      name="name"
                      placeholder="Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Email
                  </td>
                  <td>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      name="email"
                      placeholder="Email"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Phone Number
                  </td>
                  <td>
                    <input
                      type="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      name="phone"
                      placeholder="Phone #"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Type of Request
                  </td>
                  <td>
                    <select
                      style={{ width: "100%" }}
                      value={formData.type}
                      onChange={handleInputChange}
                      name="type"
                    >
                      <option value=""></option>
                      <option value="billing">Billing</option>
                      <option value="general">General</option>
                      <option value="req-mortgage-doc">Lienholder</option>
                      <option value="req-other">Other Request</option>
                      <option value="renewal-quote">New Quote</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Notes on Request
                  </td>
                  <td>
                    <textarea
                      style={{ width: "100%" }}
                      value={formData.message}
                      onChange={handleInputChange}
                      name="message"
                      placeholder="Notes"
                      rows="10"
                      cols="80"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Agent
                  </td>
                  <td>
                    {agents ? (
                      <select style={{ width: "100%" }} onChange={handleInputChange} name="agent">
                        <option value={request.agent}>-{getAgentNameFromID(request.agent)}</option>
                        {agents
                          .sort((a, b) => a.lastName.localeCompare(b.lastName))
                          .map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.lastName} {agent.firstName}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Client
                  </td>
                  <td>
                    {clients ? (
                      <select
                        style={{ width: "100%" }}
                        onChange={handleInputChange}
                        name="clientID"
                      >
                        <option value={request.client}>
                          -{getClientNameFromID(request.client)}
                        </option>
                        {clients
                          .sort((a, b) => a.lastName.localeCompare(b.lastName))
                          .map((client) => (
                            <option key={client._id} value={client._id}>
                              {client.lastName} {client.firstName}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <div>No clients yet</div>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>

            <div style={{ textAlign: "center" }}>
              <button
                className="btn-success btn-sm btn"
                onClick={(e) => handleServiceRequestUpdate(e)}
              >
                Update Service Request
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ServiceRequestUpdateForm;
